import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@service/auth.service";
import { Events } from "@service/events.service";
import { environment } from "@env/environment";
import { Profile } from "@model/Profile";
import * as moment from "moment";

@Component({
  selector: "app-auth",
  templateUrl: "./auth.component.html",
  styleUrls: ["./auth.component.scss"],
})
export class AuthComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private events: Events,
    private authenticationService: AuthService
  ) {}

  ngOnInit() {
    const token = this.route.snapshot.paramMap.get("token");
    localStorage.setItem("escritha_token", token);

    if (!token) {
      window.location.href = environment.base_server;
    }

    this.authenticationService.profile().subscribe((user: any) => {
      const differenceInDays = moment(
        user.voucher_expires_at,
        "YYYY-MM-DD"
      ).diff(new Date(), "days");

      const profile: Profile = {
        id: user.id,
        name: user.name,
        email: user.email,
        role: user.role,
        url_image: user.url_image,
        voucher_expires_at: String(differenceInDays < 0 ? 0 : differenceInDays),
        created_at: user.created_at,
        is_superuser: user.is_superuser,
        is_institution: user.is_institution,
        max_words: user.max_words,
        attending: user.attending,
        words: user.words,
        student_institution: user.student_institution,
        profile_type: user.profile_type,
        code: user.code,
      };

      localStorage.setItem("currentUser", JSON.stringify(profile));

      this.events.broadcast("profile", profile);
      this.events.broadcast("showInstitutionRoute");

      this.router.navigate(["/"]);
      // if (user.role !== 'institution') {
      // } else {
      //   this.router.navigate(['/institution']);
      // }
    });
  }
}
